import axios from 'axios';
import types from './mutations-types';

const actions = {
  async setPanelsInfo({ commit }, value) {
    commit(types.SET_PANEL_INFO, value);
  },

  async setShowSidebar({ commit }, value) {
    commit(types.SET_SHOW_CREATE_PANEL, value);
  },

  async setPanelId({ commit }, value) {
    commit(types.SET_PANEL_ID, value);
  },

  async setShowEditPanel({ commit }, value) {
    commit(types.SET_SHOW_EDIT_PANEL, value);
  },

  async setCreatePanel({ commit }, obj) {
    const panel = await axios.post(
      `${process.env.API_ROOT}/create/panel`,
      { ...obj.panelsInfo },
      { headers: { 'x-access-token': obj.token } },
    );

    commit(types.SET_PANEL, panel.data);
    return panel.data;
  },

  async setCreateCardPanel({ commit }, obj) {
    const panel = await axios.post(
      `${process.env.API_ROOT}/create/card`,
      { ...obj.cardInfo },
      { headers: { 'x-access-token': obj.token } },
    );

    commit(types.SET_CARD_PANEL, panel.data);
  },

  async getAllPanels({ commit }, obj) {
    const response = await axios.get(`${process.env.API_ROOT}/get/panels`, {
      headers: { 'x-access-token': obj.token },
      params: {
        ...obj.params,
      },
    });

    commit(types.SET_PANEL_INFO, response.data);
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/panels/actions.js